<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>外教首课签到</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" :show-message="false">
        <Row :gutter="12">
          <i-col :xs="24" :sm="12" :md="6" :lg="4">
            <Form-item label="开始日期">
              <Date-picker
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期"
                @on-change="onStartDateChange">
              </Date-picker>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="6" :lg="4">
            <Form-item label="结束日期">
              <Date-picker
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择结束日期"
                @on-change="onEndDateChange">
              </Date-picker>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="6" :lg="4">
            <Form-item label="老师ID">
              <Input name="tchId" v-model="queryParam.tchId" placeholder="请输入老师ID"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="6" :lg="4">
            <Form-item label="老师姓名">
              <Input name="tchName" v-model="queryParam.tchName" placeholder="支持模糊搜索"></Input>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="6" :lg="4">
            <Form-item label="外管">
              <Select v-model.number="queryParam.studyAdviserId" placeholder="全部" clearable>
                <Option v-for="item in studyAdviserList" :value="item.id" :key="item.id">
                  {{ item.nickname }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="6" :lg="4">
            <Form-item label="是否签到">
              <Select v-model="queryParam.hasSign" placeholder="全部" clearable>
                <Option :value="1">已签到</Option>
                <Option :value="0">未签到</Option>
                <Option :value="2">晚签到</Option>
                <Option :value="3">迟签到</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="6" :lg="4">
            <Form-item label="上课时间">
              <Time-picker
                type="time"
                format="HH:mm"
                value-format="HH:mm:ss"
                placeholder="选择上课时间"
                @on-change="onLsnBeginTimeChange">
              </Time-picker>
            </Form-item>
          </i-col>
          <i-col :xs="24" :sm="12" :md="6" :lg="4">
            <Form-item>
              <Button type="primary" :loading="searchLoading" @click="search">查询</Button>
<!--              <Button type="primary" :loading="exportLoading" @click="exportData" style="margin-left: 10px">导出</Button>-->
            </Form-item>
          </i-col>
        </Row>
      </Form>
    </div>

    <div class="table-container">
      <Table
        :columns="columns"
        :data="tableData"
        :loading="tableLoading"
        border
        stripe
        @on-sort-change="handleSortChange">
      </Table>
      <div style="margin: 10px; overflow: hidden">
        <div style="float: right;">
          <Page
            :total="pagination.totalCount"
            :current="pagination.pageIndex"
            :page-size="pagination.pageSize"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
            show-sizer
            show-elevator
            show-total>
          </Page>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'

export default {
  name: 'TchFirstCheckList',
  data () {
    return {
      searchLoading: false,
      rankScoreSeq: 0,
      exportLoading: false,
      tableLoading: false,
      queryParam: {
        tchId: '',
        tchName: '',
        studyAdviserId: '',
        hasSign: '',
        lsnBeginTime: '',
        pageIndex: 1,
        pageSize: 10
      },
      studyAdviserList: [],
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0
      },
      tableData: [],
      columns: [
        {
          title: '老师ID',
          key: 'tchId',
          width: 100,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '老师姓名',
          key: 'tchName',
          width: 160,
          align: 'center',
          fixed: 'left',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.tchName,
              score: row.monthRankScore
            })
          }
        },
        {
          title: '外管姓名',
          key: 'fmName',
          width: 120,
          align: 'center',
          fixed: 'left'
        },
        {
          title: 'HR',
          key: 'hr',
          width: 100,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '国籍',
          key: 'nationality',
          width: 100,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '时差',
          key: 'timeDiff',
          width: 80,
          align: 'center',
          fixed: 'left'
        },
        // 动态列将在 mounted 中根据签到信息添加
      ]
    }
  },
  mounted () {
    // 获取外管列表
    this.getStudyAdviserList()
    // 初始化加载数据
    this.search()
  },
  methods: {
    loadMonthRankScores () {
      const table = this.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
      })
    },

    // 获取外教运营列表
    getStudyAdviserList () {
      let self = this
      self.$http.post('/adminUser/listByCondition', {adminGroupId: 7, status: 1}).then(function (res) {
        if (!res || !res.data) {
          return
        }
        self.studyAdviserList = res.data
      })
    },
    search () {
      this.tableLoading = true
      this.searchLoading = true

      let params = {...this.queryParam}
      params.pageIndex = this.pagination.pageIndex
      params.pageSize = this.pagination.pageSize

      this.$http.post('/tchSignLog/foreign-teacher-first-check', params).
        then((res) => {
          if (res && res.data && res.data.data) {
            this.tableData = res.data.data
            this.loadMonthRankScores()
            this.pagination.totalCount = res.data.totalCount
            this.pagination.pageIndex = res.data.pageIndex
            this.pagination.pageSize = res.data.pageSize
            // 动态生成签到信息列
            this.generateSignInfoColumns(res.data.data)
          } else {
            if (res.msg) {
              this.$Message.error(res.msg)
            }
            this.tableData = []
            this.pagination.totalCount = 0
          }
        }).catch(() => {
          this.tableData = []
          this.pagination.totalCount = 0
        }).
        finally(() => {
          this.tableLoading = false
          this.searchLoading = false
        })
    },
    // 动态生成签到信息列
    generateSignInfoColumns (data) {
      // 清除之前的动态列
      this.columns = this.columns.filter(col => !col.isDynamic)

      // 收集所有可能的签到日期和星期信息
      const signDateMap = new Map()
      data.forEach(item => {
        if (item.signInfoList && Array.isArray(item.signInfoList)) {
          item.signInfoList.forEach(signInfo => {
            const key = signInfo.signDate
            if (!signDateMap.has(key)) {
              signDateMap.set(key, signInfo.week || '')
            }
          })
        }
      })

      // 按日期排序，从大到小
      const sortedDateEntries = Array.from(signDateMap.entries()).sort((a, b) => b[0].localeCompare(a[0]))

      // 为每个日期创建一列
      sortedDateEntries.forEach(([date, week]) => {
        this.columns.push({
          title: date,
          key: `sign_${date}`,
          width: 120,
          align: 'center',
          isDynamic: true,
          renderHeader: (h) => {
            return h('div', [
              h('div', date),
              h('div', {style: {fontSize: '12px', color: '#999', marginTop: '2px'}}, week)
            ])
          },
          render: (h, params) => {
            const row = params.row
            if (row.signInfoList && Array.isArray(row.signInfoList)) {
              const signInfo = row.signInfoList.find(info => info.signDate === date)
              if (signInfo) {
                const firstLine = h('div', { style: { marginBottom: '4px' } }, '首课：' + (signInfo.firstLessonTime || ''))
                let secondLine = h('div', {}, '签到:-')
                if (signInfo.signTime) {
                  let style = {}
                  // 0-正常签到(绿色), 1-晚签到(红色), 2-迟签到(橙色)
                  if (signInfo.lateSign === 0) {
                    style = { color: '#19be6b' } // 绿色 - 正常
                  } else if (signInfo.lateSign === 1) {
                    style = { color: '#ed4014' } // 红色 - 晚签到，异常
                  } else if (signInfo.lateSign === 2) {
                    style = { color: '#ff9900' } // 橙色 - 迟签到，警告
                  }
                  secondLine = h('div', { style: style }, '签到:' + signInfo.signTime)
                }
                const container = h('div', { style: { display: 'flex', flexDirection: 'column' } }, [firstLine, secondLine])
                return container
              }
            }
            return h('span', '-')
          }
        })
      })
    },
    exportData () {
      this.exportLoading = true

      let params = {...this.queryParam}
      params.pageIndex = 1
      params.pageSize = 999999 // 导出所有数据

      this.$http.post('/tchSignLog/foreign-teacher-first-check-export', params, {responseType: 'blob'}).
        then((response) => {
          const blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '外教首课签到.xlsx'
          link.click()
          this.$Message.success('导出成功')
        }).
        catch((error) => {
          this.$Message.error('导出失败：' + error.message)
        }).
        finally(() => {
          this.exportLoading = false
        })
    },
    changePage (pageIndex) {
      this.pagination.pageIndex = pageIndex
      this.search()
    },
    changePageSize (pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.pageIndex = 1
      this.search()
    },
    handleSortChange (column) {
      // 排序功能可以根据需要实现
      console.log('排序字段:', column.key, '排序方式:', column.order)
    },
    onStartDateChange (value) {
      // 将日期转换为 yyyy-MM-dd 格式
      if (value) {
        this.queryParam.startDate = this.$moment(value).format('YYYY-MM-DD')
      } else {
        this.queryParam.startDate = ''
      }
    },
    onEndDateChange (value) {
      // 将日期转换为 yyyy-MM-dd 格式
      if (value) {
        this.queryParam.endDate = this.$moment(value).format('YYYY-MM-DD')
      } else {
        this.queryParam.endDate = ''
      }
    },
    onLsnBeginTimeChange (value) {
      // 将 HH:mm:ss 格式转换为 HH:mm 格式
      if (value) {
        this.queryParam.lsnBeginTime = value.substring(0, 5)
      } else {
        this.queryParam.lsnBeginTime = ''
      }
    },
  }
}
</script>

<style scoped>
.list {
  padding: 20px;
}

.breadcrumb {
  margin-bottom: 20px;
}

.search {
  background: #f8f8f9;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.table-container {
  background: white;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.ivu-table-wrapper {
  border: none;
}

.ivu-table th {
  background-color: #f8f8f9;
  font-weight: bold;
}
</style>




// WEBPACK FOOTER //
// TchFirstCheckList.vue?2bc1361a